import {ReactNode} from 'react';
import style from './style.module.scss';
import {Box, Col, Row} from 'components/Grid';

export const BottomBlock = ({children}: {children: ReactNode}) => (
    <div className={style.bottomBlock}>
        <Box>
            <Row>
                <Col>{children}</Col>
            </Row>
        </Box>
    </div>
);
